const EVENTS = {
  VIEWPORT_ROTATED: 'viewportRotated',
};

export default EVENTS;
